export default "__VITE_ASSET__BZ3R5E8e__"